import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=3c22517a&"
import script from "./voice.vue?vue&type=script&lang=js&"
export * from "./voice.vue?vue&type=script&lang=js&"
import style0 from "./voice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports